import * as React from 'react';
import { ToneDetailsPopupComponent, ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { GiftAFriendComponentHandler, GiftAFriendComponentProps, GiftAFriendComponentState } from './giftafriendcomponent';
import { GiftAFriendCSSStyle } from './giftafriendcss';
import { Strings } from '../../../../utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { GiftToneDto, GiftToneDtoImpl } from '../../../../core/dto/gifttone/gifttonedto';
import { FloatingTextComponent } from '../../../toolkit/floatingtext/floatingtextcomponent';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import { LoaderWrapperComponent } from '../loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';

import './giftafriend-style.css';

export class GiftAFriendViewImpl extends UIComponentViewImpl<GiftToneDto>
{
    private loaderWrapperComponent:LoaderWrapperComponent;
    private contactNumber: FloatingTextComponent;

    bindHandlers()
    {   
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onValidateClick = this.onValidateClick.bind(this);
        this.onKeyPressEvent = this.onKeyPressEvent.bind(this);
        document.addEventListener("keydown",this.onKeyPressEvent);
    }

    draw(props: GiftAFriendComponentProps, state: GiftAFriendComponentState, cssStyle: GiftAFriendCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
              {
                this.getWebView(props, state, cssStyle)
            }
           
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </div>
        );
    }

    getWebView(props: GiftAFriendComponentProps, state: GiftAFriendComponentState, cssStyle: GiftAFriendCSSStyle)
    {
        return (
            <>
             <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={props.context.getResources().getString(Strings.gift_a_friend)} toneDto={props.toneDto} context={props.context}/>
                
                <div id="gifttone-main">
                             
                             <div id="gifttone-header-main">
                                      <label id="gifttone-header-price">
                                          {this.getContext().getResources().getString(Strings.tune_charge)}
                                      </label>
                                      <label id="gifttone-header-absolute-validity">
                                          {this.getContext().getResources().getString(Strings.absolute_validity)}
                                      </label>
                              </div> 
                              <div id="gifttone-header-value">
                                     <label id="gifttone-header-price-value">
                                          {state.price}
                                      </label>
                                      <label id="gifttone-header-absolute-validity-value">
                                      {props.toneDto.getExpirydate()}
                                      </label>
                              </div>
                    </div>          
                    {!state.isPrice &&
                         <div style={cssStyle.getContactNumberCSSStyle()}>
                             <MsisdnFloatingTextComponent hint={props.context.getResources().getString(Strings.mobilenumberhint)} maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => {this.contactNumber = item;}} id={"#contactNumber"} value={state.msisdn} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.friend_number)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.invalidcontactnumber)}/>
                     </div>
                    }
             
                 {
                     state.isPrice ? 
                     <div style={cssStyle.getConfirmButtonCSSStyle()}>
                         <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
                     </div>
                     :
                     <div style={cssStyle.getConfirmButtonCSSStyle()}>
                     <ButtonComponent onClick={this.onValidateClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={this.getContext().getResources().getString(Strings.verify)}/>
                 </div>
                 }
            </>
        );
    }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    
   
    // getPrice(tonePriceDto:GetTonePriceDto):string
    // {
    //     tonePriceDto.
    // }
    validate(): boolean
    {
        // if(this.contactNumber.validate())
        // {
        //     let numberMinLength = +this.getUIProps().context.getResources().getString(Strings.numberMinLength);
        //     let numbermaxLength = +this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

        //     if(this.contactNumber.getData().length < numberMinLength 
        //                     || this.contactNumber.getData().length > numbermaxLength)
        //     {
        //         this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
        //         return false;
        //     }
            
        //     return true;
        // }
        // return false;
        if(this.contactNumber.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.contactNumber.getData());
            
            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

           
            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }
            else if(this.getContext().getUserContext().getMsisdn() === this.contactNumber.getData())
            {
                this.contactNumber.setErrorMessage(this.getContext().getResources().getString(Strings.number_cannot_be_same_as_the_logged_in_number));
                return false;
            }
            
            return true;   
        } 
        return false;    
    }
    onKeyPressEvent(event:any):void
    {
        console.log("key code", event.code+event.keyCode);
          if(event.code === "Enter")
          {
              this.onConfirmClick();
          }
    }

    getData(): GiftToneDto
    {
        let toneDto = (this.getUIProps() as GiftAFriendComponentProps).toneDto;
        let request = new GiftToneDtoImpl();
        request.setToneId((this.getUIProps() as GiftAFriendComponentProps).toneOptionsType 
        === ToneOptionsType.TONE ? toneDto.getId(): toneDto.getContentId().split("|")[0]);
        request.setToneName(toneDto.getToneName());
        request.setMsisdnA(this.getUIProps().context.getUserContext().getMsisdn());
        request.setLanguage(this.getUIProps().context.getUserContext().getLanguage());
        request.setMsisdnB(this.contactNumber !== undefined && this.contactNumber !== null ? this.contactNumber.getData() : 
        (this.getUIState() as GiftAFriendComponentState).msisdn);
        request.setPackName((this.getUIState() as GiftAFriendComponentState).packName);
        request.setChannelId(this.getUIProps().context.getUserContext().getChannelId());
        request.setUserName(this.getUIProps().context.getUserContext().getUsername());

        return request;
    }

    private onConfirmClick()
    {
        (this.getUIComponentHandler() as GiftAFriendComponentHandler).onConfirmClick();
    }

    private onValidateClick()
    {
        (this.getUIComponentHandler() as GiftAFriendComponentHandler).onValidateClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/giftafriend/giftafriendview.tsx